// Sidebar Edit Components
import { TitleBlockEditSidebar } from './title/title-block-edit-sidebar'
import { ImageBlockEditSidebar } from './image/image-block-edit-sidebar'
import { LineBlockEditSidebar } from './line/line-block-edit-sidebar'
import { BarBlockEditSidebar } from './bar/bar-block-edit-sidebar'
import { TableBlockEditSidebar } from './table/table-block-edit-sidebar'
import { MapBlockEditSidebar } from './map/map-block-edit-sidebar'
import { SankeyBlockEditSidebar } from './sankey/sankey-block-edit-sidebar'
import { SunburstBlockEditSidebar } from './sunburst/sunburst-block-edit-sidebar'
import { ForestBlockEditSidebar } from './forest/forest-block-edit-sidebar'

// Inline Edit Components
import { TextBlockEditInline } from './text/text-block-edit-inline'
import { TableTypeChoiceBlock } from './table/table-type-choice-block'
import { ImageBlockEditInline } from './image/image-block-edit-inline'
import { LineBlockEditInline } from './line/line-block-edit-inline'
import { BarBlockEditInline } from './bar/bar-block-edit-inline'
import { MapBlockEditInline } from './map/map-block-edit-inline'
import { SankeyBlockEditInline } from './sankey/sankey-block-edit-inline'
import { SunburstBlockEditInline } from './sunburst/sunburst-block-edit-inline'
import { PageControlBarEditSidebar } from './page-control-bar/page-control-bar-edit-sidebar'
import { DescriptionBlockEditSidebar } from './description/description-block-edit-sidebar'
import { ForestBlockEditInline } from './forest/forest-block-edit-inline'

export const blockEditComponents = {
  bar: {
    inline: BarBlockEditInline,
    sidebar: BarBlockEditSidebar
  },
  forest: {
    inline: ForestBlockEditInline,
    sidebar: ForestBlockEditSidebar
  },
  image: {
    inline: ImageBlockEditInline,
    sidebar: ImageBlockEditSidebar
  },
  line: {
    inline: LineBlockEditInline,
    sidebar: LineBlockEditSidebar
  },
  map: {
    inline: MapBlockEditInline,
    sidebar: MapBlockEditSidebar
  },
  sankey: {
    inline: SankeyBlockEditInline,
    sidebar: SankeyBlockEditSidebar
  },
  sunburst: {
    inline: SunburstBlockEditInline,
    sidebar: SunburstBlockEditSidebar
  },
  table: {
    inline: TableTypeChoiceBlock,
    sidebar: TableBlockEditSidebar
  },
  title: {
    sidebar: TitleBlockEditSidebar
  },
  description: {
    sidebar: DescriptionBlockEditSidebar
  },
  text: {
    inline: TextBlockEditInline
  },
  pageControlBar: {
    sidebar: PageControlBarEditSidebar
  }
}
